module.exports = "<router-outlet></router-outlet>\r\n\r\n<app-info></app-info>\r\n<app-success></app-success>\r\n<app-warning></app-warning>"


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main